<template>
  <div class="final-gradient-chart">
    <b-row class="mb-3">
      <b-col>
        <label>
          {{ $t('engineering.final-gradient.select-winding') }}
        </label>
        <s-select
          v-model="selectedWinding"
          value-field="id"
          text-field="name"
          :options="windingOptions"
          @change="getChartData(true, true)"
        />
      </b-col>
    </b-row>
    <div class="final-gradient-chart__box">
      <default-chart
        chart-id="final-gradient-chart"
        x-data-manager="dateTime"
        :key="chartRenderKey"
        :chart-data="chartData"
        :loading="loading"
        :remove-outlier.sync="removeChartOutlier"
        :enable-multi-axis.sync="enableChartMultiAxis"
        :colors-list="chartColors"
        @toggle-outlier="getChartData(true)"
        @toggle-multi-axis="getChartData(true)"
      />
    </div>
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import { getColorsListByLength } from '@/domain/data/charts/chartColors';
import engineeringEvents from '@/domain/events/engineering';
import DefaultChart from '@/components/charts/DefaultChart';
import defaultChartMixin from '@/domain/mixins/defaultChartMixin';
import finalGradientGraphicIds from '@/domain/data/installation/engineering/finalGradient/finalGradientGraphicIds';
import Service from '@/domain/services/installation/engineering/finalGradient/finalGradientService';

export default {
  name: 'FinalGradientChartTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { DefaultChart },
  mixins: [defaultChartMixin],
  data: () => ({
    chartData: [],
    loading: false,
    selectedWinding: 1,
    chartRenderKey: 0,
  }),
  created() {
    this.init();
    this.refreshData(true);
  },
  beforeDestroy() {
    this.deinit();
  },
  computed: {
    windingOptions() {
      const { windingAmount } = this.tabInfo;
      const options = [];

      for (let index = 1; index <= windingAmount; index += 1) {
        options.push({ id: index, name: `${this.$t('general.winding')} ${index}` });
      }

      return options;
    },
    chartColors() {
      return getColorsListByLength((this.chartData || []).length);
    },
  },
  methods: {
    init() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    deinit() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    refreshData(showLoading = false) {
      if (!this.tabInfo.windingAmount) return;
      this.getChartData(showLoading);
    },
    sortChartDataByType(chartData) {
      const ids = finalGradientGraphicIds[`winding${this.selectedWinding}`];
      const orderList = Object.values(ids);
      const orderedItems = chartData.filter(item => orderList.includes(item.id));
      const unorderedItems = chartData.filter(item => !orderList.includes(item.id));

      orderedItems.sort((a, b) => orderList.indexOf(a.id) - orderList.indexOf(b.id));

      return [
        ...orderedItems,
        ...unorderedItems,
      ];
    },
    resetChart() {
      this.removeChartOutlier = false;
      this.enableChartMultiAxis = true;
      this.renewChartKey();
    },
    renewChartKey() {
      this.chartRenderKey += 1;
    },
    getChartData(showLoading = false, resetChart = false) {
      this.loading = showLoading;
      const queryString = {
        ...this.chartFilters,
        windingId: this.selectedWinding,
      };

      Service.getChart(this.$route.params.assetModuleId, queryString)
        .then((response) => {
          this.chartData = this.sortChartDataByType(response);
          if (resetChart) {
            this.resetChart();
          }
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.final-gradient-chart
  &__box
    min-width: 100%
    padding: 15px
    border: 1px solid var(--color-border-dark)
    border-radius: 3px
</style>
